import React from "react";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumb from "../../../base/components/Common/Breadcrumb2";
import ReportsTable from "./components/ReportsTable";
import useConfig from "../../../base/hooks/useConfig";

const breadcrumbs = {
  title: "Dashboard", breadcrumbItems: []
}

export default function Dashboard() {
  const { config, isConfigLoading } = useConfig();
  const dnaReportUrl = config?.REACT_APP_DNA_REPORT_URL;

  return (
    <Container fluid className="content">
      <Breadcrumb {...breadcrumbs} />
      {dnaReportUrl ? (
        <ReportsTable />
      ) : (
        <Card>
          <CardBody>
            <ReportsTable />
          </CardBody>
        </Card>
      )}
    </Container>
  );
}